module.exports = __webpack_public_path__ + "static/rvi-af3edda38c7da9d0163dd917d3e38a83.png";